import {Component, computed, input} from '@angular/core';

@Component({
  selector: 'loading-pulse',
  imports: [],
  templateUrl: './loading-pulse.component.html',
})
export class LoadingPulseComponent {
  pulseCount = input<number>(10);
  pulseItems = computed(() => Array.from({length: this.pulseCount()}));
}
